export default "__VITE_ASSET__CsInAHnP__"